export const localOrderIdKey = (slug?: string) =>
  slug ? `_local_${slug}_order_id` : '_local_order_id'
export const localOrderKey = (slug?: string) => (slug ? `_local_${slug}_order` : '_local_order')
export const localBuyNowOrderKey = (slug?: string) =>
  slug ? `_local_${slug}_buynow_order` : '_local_buynow_order'
export const localPurchasedOrderKey = (slug?: string) =>
  slug ? `_local_${slug}_purchased_order` : '_local_purchased_order'
export const localIsBuyNowKey = (slug?: string) =>
  slug ? `_local_${slug}_isbuynow` : '_local_isbuynow'
export const localIsPayingKey = (slug?: string) =>
  slug ? `_local_${slug}_ispaying` : '_local_ispaying'
export const localDiscountCodeKey = (slug?: string) =>
  slug ? `_local_${slug}_discount_code` : '_local_discount_code'
export const localSourceEventKey = (slug?: string) =>
  slug ? `_local_${slug}_source_event` : '_local_source_event'
export const localShippingAddressKey = '_local_shipping'
export const lastPLabelItem = '_local_last_p_label_item_'
export const isPayingWithPaypalKey = 'is_paying_paypal'
export const priceChangedVariantItemsKey = (slug?: string) =>
  slug ? `items_${slug}_changed_price` : 'items_changed_price'
export const sessionIdKey = '_local_session_id'
export const userIdKey = '_local_user_id'
export const sellpageIdKey = '_local_sellpage_id'
export const isPurchaseKey = (slug?: string) =>
  slug ? `_local_${slug}_is_purchase` : '_local_is_purchase'

export const stripePaymentConfirm = '_local_stripe_confirm'
export const localStripePaymentConfirmKey = (slug?: string) =>
  slug ? `_local_${slug}_stripe_confirm` : '_local_stripe_confirm'
export const localOtpOutKey = (slug?: string) => (slug ? `_local_${slug}_otpout` : '_local_otpout')
export const localpaymentTypeOrderKey = '_local_payment_type_order'

export const localIsCollectTax = '_local_is_collect_tax'
export const completeCard = '_is_local_complete_card'
export const localVisitTimeKey = '_local_local_visit'
export const eventIdFbKey = 'event_id_fb'

export const localIsPaypalThankYouId = (slug?: string) =>
  slug ? `_local_is_paypal_${slug}_thank_you` : 'is_paypal_thank_you'

export const localOrderPaypalId = (slug?: string) =>
  slug ? `_local_${slug}_paypal_order_id` : '_local_paypal_order_id'
export const isMaxQuantityDiscount = 'is_max_quantity_discount'
export const isMaxQuantityDiscountProduct = 'is_max_quantity_discount_product'
export const isMaxItemNegative = 'is_max_item_negative'
export const expiredDiscountKey = 'is_expired_discount'
export const tokenBrKey = 'token_br'
export const minPriceThankyou = 'min_price_thankyou'
export const isApplePayActive = 'is_apple_pay_active'
export const isAbandoned = 'is_abandoned'
export const isGooglePayActive = 'is_google_pay_active'
export const hasUpsellKey = 'has_upsell'

export const versionCookie = [
  'v13',
  'v14',
  'v141',
  'v142',
  'br1',
  'vx141',
  'v144',
  'e144',
  'v146',
  'a144',
  'c144',
  'a145',
  'b144',
  'ba10', // Add checked mark for verified buyer + Add checkmark on selection
  'ba11',
  'ba23',
  'bb23',
  'p144', // policy
  'd144',
  'o144',
  'g144',
  'r144',
  'l144',
  'i144',
  'x144', //base new
  'z144', //base new
  'k144', //base new
  'f144', //base new
  'y144', //base new
  'h144', //base new
  'vta1',
  'c145',
  'vta3',
  'vta31',
  'c146',
  'vta2',
  'usp1', //usp
  'usp2',
  'usp3',
  'usp4',
  'vcdn3',
  'acdn3',
  'vap1',
  'gp01a',
  'gp01b',
  'gp02',
  'vlz1',
  'vpo1',
  'vpl1',
  'vna2',
  'vli1',
  'vta4',
  'v145',
  'apv1', // Apple Pay
  'apv2', // Apple Pay,
  'apv21', // Apple Pay version base trên apv2
  'apv3', // New Apple Pay version for buy it now
  'm144', // New version base,
  'ab144', // New version base,
  'ac144', // New version base,
  'apv5', // enhanced version for Apple Pay,
  'apv6',
  'apv51',
  'a25v26',
  'b25v24',
  'f25v51',
  'f25v26',
  'f25v511',
  'f25v61',
  'f25v611',
  'f25v20',
  'f25v612',
  'f25v52',
  'f25v521',
  'f25v31'
]

export const listVersionUsp = ['usp1', 'usp2', 'usp3', 'usp4', 'p144', 'd144', 'v144']
export const gaExcludes = ['rosiedelight.com', 'maracharm.com']
export type showValueCD = 'NONE' | 'POPUP' | 'TEXT'

export const MOBILE_APP_EVENTS = Object.freeze({
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  CART_REMOVE_ITEM: 'CART_REMOVE_ITEM',
  CART_CHOOSE_QUANTITY: 'CART_CHOOSE_QUANTITY',
  CHECKOUT_ADDRESS_FIELD_TAPPED: 'CHECKOUT_ADDRESS_FIELD_TAPPED',
  CHECKOUT_ADDRESS_FIELD_FILLED: 'CHECKOUT_ADDRESS_FIELD_FILLED',
  CHECKOUT_CARD_PAY: 'CHECKOUT_CARD_PAY',
  CHECKOUT_CARD_INFO_TAPPED: 'CHECKOUT_CARD_INFO_TAPPED',
  CHECKOUT_CARD_INFO_FILLED: 'CHECKOUT_CARD_INFO_FILLED',
  CHECKOUT_PAYMENT_INFO_FILLED: 'CHECKOUT_PAYMENT_INFO_FILLED',
  ADD_PAYMENT_INFO: 'ADD_PAYMENT_INFO',
  INIT: 'INIT',
  COMPLETE_CHECKOUT_STRIPE: 'COMPLETE_CHECKOUT_STRIPE',
  CHECKOUT_EMAIL_FIELD_TAPPED: 'CHECKOUT_EMAIL_FIELD_TAPPED',
  CHECKOUT_EMAIL_FIELD_FILLED: 'CHECKOUT_EMAIL_FIELD_FILLED',
  BACK: 'BACK',
  CLOSE: 'CLOSE',
  CHECKOUT_APPLE_PAY_ACTIVE: 'CHECKOUT_APPLE_PAY_ACTIVE',
  CHECKOUT_APPLE_PAY_INACTIVE: 'CHECKOUT_APPLE_PAY_INACTIVE',
  BACK_TO_HOME: 'BACK_TO_HOME',
  CART_CHECKOUT_PAYPAL: 'CART_CHECKOUT_PAYPAL',
  CHECKOUT_PAYPAL_TAPPED: 'CHECKOUT_PAYPAL_TAPPED',
  COMPLETE_CHECKOUT_PAYPAL: 'COMPLETE_CHECKOUT_PAYPAL',
  CART_PROCEED_CHECKOUT: 'CART_PROCEED_CHECKOUT',
  UPDATE_CART: 'UPDATE_CART',
  CHECKOUT_VIEW_APPEAR: 'CHECKOUT_VIEW_APPEAR',
  CHECKOUT_VIEW_DISAPPEAR: 'CHECKOUT_VIEW_DISAPPEAR',
  CHECKOUT_APPLE_PAY_TAPPED: 'CHECKOUT_APPLE_PAY_TAPPED',
  REDIRECT_TO_CONTACT: 'REDIRECT_TO_CONTACT',
  REDIRECT_TO_ORDER_LIST: 'REDIRECT_TO_ORDER_LIST',
  INIT_CHECKOUT: 'INIT_CHECKOUT',
  SELECT_UPSELL: 'SELECT_UPSELL',
  CART_PAYPAL_CANCEL: 'CART_PAYPAL_CANCEL',
  CHECKOUT_PAYPAL_CANCEL: 'CHECKOUT_PAYPAL_CANCEL',
  UPSELL_SHOWN: 'UPSELL_SHOWN',
  ORDER_SUMMARY_TAPPED: 'ORDER_SUMMARY_TAPPED',
  CUSTOMER_INFO_TAPPED: 'CUSTOMER_INFO_TAPPED'
})
